export default "__VITE_ASSET__0ab6dc03__"